import u from "./_common.js";
import x from "../../_styles/common/light.js";
function v(l) {
  const {
    primaryColor: t,
    borderRadius: e,
    lineHeight: c,
    fontSize: o,
    cardColor: d,
    textColor2: i,
    textColor1: n,
    dividerColor: a,
    fontWeightStrong: s,
    closeIconColor: m,
    closeIconColorHover: C,
    closeIconColorPressed: g,
    closeColorHover: f,
    closeColorPressed: b,
    modalColor: S,
    boxShadow1: h,
    popoverColor: p,
    actionColor: r
  } = l;
  return Object.assign(Object.assign({}, u), {
    lineHeight: c,
    color: d,
    colorModal: S,
    colorPopover: p,
    colorTarget: t,
    colorEmbedded: r,
    colorEmbeddedModal: r,
    colorEmbeddedPopover: r,
    textColor: i,
    titleTextColor: n,
    borderColor: a,
    actionColor: r,
    titleFontWeight: s,
    closeColorHover: f,
    closeColorPressed: b,
    closeBorderRadius: e,
    closeIconColor: m,
    closeIconColorHover: C,
    closeIconColorPressed: g,
    fontSizeSmall: o,
    fontSizeMedium: o,
    fontSizeLarge: o,
    fontSizeHuge: o,
    boxShadow: h,
    borderRadius: e
  });
}
const z = {
  name: "Card",
  common: x,
  self: v
}, P = z;
export {
  P as default,
  v as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/card/styles/light.js
// module id = 905
// module chunks = 41